import { Col, Row, Steps as AntSteps } from 'antd'
import { StepsProps } from 'antd/lib/steps'
import { Steps as AntMobileSteps } from 'antd-mobile'
import { StepsProps as MobileStepsProps } from 'antd-mobile/lib/steps'
import { ComponentProps } from 'react'
import * as React from 'react'

import MobileFriendly from '../General/MobileFriendly'

interface Props extends Omit<StepsProps & MobileStepsProps, 'children'> {
  steps: Array<ComponentProps<typeof AntSteps.Step | typeof AntMobileSteps.Step>>
  onStepClick?: (step: number) => void
  prevButton?: React.ReactNode
  nextButton?: React.ReactNode
  showTitleOnMobile?: boolean
}

const MobileSteps = ({
  steps,
  onStepClick,
  prevButton,
  current,
  nextButton,
  showTitleOnMobile,
  ...others
}: Props) => {
  const Step = ({ index, ...others }: { index: number }) => {
    return (
      <If condition={steps[index]}>
        <AntMobileSteps.Step
          onClick={() => onStepClick(index)}
          {...steps[index]}
          {...others}
          key={steps[index].key}
        />
      </If>
    )
  }

  return (
    <Row gutter={[0, 12]}>
      <Col span={24}>
        <AntMobileSteps direction="horizontal" current={current} {...others}>
          <Step index={0} key={'step-0'} />
          <Step index={1} key={'step-1'} />
          <Step index={2} key={'step-2'} />
          <Step index={3} key={'step-3'} />
          <Step index={4} key={'step-4'} />
        </AntMobileSteps>
      </Col>
      <If condition={showTitleOnMobile && steps.length > 3}>
        <Col xs={{ span: 22, offset: 1 }}>
          <Row justify="space-between" align="middle">
            <Col>{prevButton}</Col>
            <Col>{steps[current]?.title}</Col>
            <Col>{nextButton}</Col>
          </Row>
        </Col>
      </If>
    </Row>
  )
}

const Steps: React.FC<Props> = (props) => {
  const {
    current,
    status,
    steps,
    onStepClick,
    direction = 'vertical',
    className = '',
    prevButton = null,
    nextButton = null,
    showTitleOnMobile = true,
    ...others
  } = props

  const handleStepClick = (step: number) => {
    onStepClick && onStepClick(step)
  }

  return (
    <MobileFriendly<StepsProps | MobileStepsProps>
      mobile={
        <MobileSteps
          prevButton={prevButton}
          nextButton={nextButton}
          onStepClick={handleStepClick}
          showTitleOnMobile={showTitleOnMobile}
          {...props}
        />
      }
      desktop={
        <AntSteps>
          {steps.map((step, index) => (
            <AntSteps.Step onClick={() => handleStepClick(index)} {...step} key={index} />
          ))}
        </AntSteps>
      }
      current={current}
      direction={direction}
      status={status}
      className={`${steps.length > 3 ? 'small-steps' : ''} ${className}`}
      breakpoint="md"
      {...others}
    />
  )
}

export default Steps
